import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const Base64Decoder = () => {
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting, isDirty, isValid },
  } = useForm({ mode: "onChange" });
  const [base64DecodedString, setBase64DecodedString] = useState(null);

  const onSubmit = (data) => {
    if (data.value) {
      const decoded = atob(data.value);
      if (decoded) {
        setBase64DecodedString(decoded);
      }
    }
  };

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data);
    toast.success("Copied.");
  };

  const faqs = [
    {
      title: "What is Base64?",
      desc: "Base64 is a binary-to-text encoding that represents binary data using printable ASCII characters. It converts data like images or files into text format for safe transmission over text-based systems, using 64 characters for encoding. Not encryption, it's widely used for data embedding in URLs, HTML, emails, etc.",
    },
    {
      title: "What is Base64 used for?",
      desc: "Base64 is used for encoding binary data into a text format, using a set of printable ASCII characters. It's widely used for safe data transmission over text-based protocols like HTTP, embedding images in HTML, including attachments in emails, storing binary data in JSON, and more. It's not encryption, but a way to represent binary data as text.",
    },
    {
      title: "Is this converter free?",
      desc: "Yes, this Base64 decoder and encoder is completely free made by App Upgrade Team. Feel free to bookmark this page.",
    },
    {
      title: "Is my data safe?",
      desc: "We don't store the data entered by you. The conversion takes place in your browser locally.",
    },
  ];

  return (
    <section className="landing-page-section bg-landing-page">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-xl-8 col-lg-8 col-md-8">
            <div className="section-title text-center title-ex1 mb-4">
              <p>
                <Link className="" to={"/utilities"}>
                  ← All Developer Utilities
                </Link>{" "}
              </p>
              <h2 className="light-purple-gradient">Base64 Decoder</h2>
              <p
                className="landing-muted-text"
                style={{ fontSize: "large", fontWeight: "normal" }}
              >
                Decode from Base64 format using this free tool by App Upgrade.
              </p>
            </div>
          </div>

          <Container>
            <Row className="dark-mode justify-content-center mb-4">
              <Col lg={12} md={8} className="">
                <form className="form" onSubmit={handleSubmit(onSubmit)}>
                  <label className="text-cool-black mt-2">Base64</label>
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <textarea
                        name="value"
                        className="form-control"
                        ref={register({ required: true })}
                        placeholder="*Enter value"
                        rows="4"
                      />
                      {errors.message && (
                        <p className="error">Value is required</p>
                      )}
                    </div>
                  </div>
                  <div className="d-flex mt-1">
                    <div className="form-group">
                      <button
                        className="btn btn-danger btn-block gradient-bg-accent"
                        type="submit"
                        disabled={!isDirty && !isValid}
                      >
                        {isSubmitting ? 'Decoding...' : 'Decode'}
                      </button>
                    </div>
                  </div>
                </form>
                <div className="form pt-0">
                  <label className="text-cool-black mt-4">Decoded Text </label>
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <textarea
                        name="value"
                        className="form-control"
                        rows="4"
                        defaultValue={base64DecodedString}
                      />
                    </div>
                    <div className="">
                      <button
                        className="btn outline-text gradient-bg-accent"
                        onClick={() => handleCopy(base64DecodedString)}
                        disabled={!base64DecodedString}
                      >
                        <div className="d-flex align-items-center gap">
                          <FontAwesomeIcon className="fa-thin" icon={faCopy} />
                          <span class="pl-2">Copy to Clipboard</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              {faqs.map((faq, key) => (
                <Col className="mt-10" key={key} lg={6} md={6}>
                  <div style={{ textAlign: "left" }}>
                    <div className="d-flex justify-content-start">
                      <div
                        style={{ marginBottom: "0px", paddingRight: "4px" }}
                      ></div>
                      <h5 className="text-white">{faq.title}</h5>
                    </div>

                    <p
                      className="landing-muted-text mb-4"
                      style={{ fontSize: "1rem" }}
                    >
                      {faq.desc}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
            <Row className="justify-content-center mt-10 mb-4">
              <Col lg={12} md={8} className="">
                <div className="title text-center m-4">
                  <h1 className="font-weight-bolder line-height-1_4 text-white">
                    Easily{" "}
                    <span className="light-purple-gradient">force update</span>{" "}
                    your mobile apps.
                  </h1>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg={6} md={8}>
                <div className="title text-center mb-5">
                  <span
                    className="text-white text-landing-h1"
                    style={{ fontSize: "2.0rem" }}
                  >
                    Start with{" "}
                    <span className="light-purple-gradient">App Upgrade</span>,
                    today.
                  </span>
                  <p
                    className="light-purple-gradient mt-3"
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: "normal",
                      color: "rgba(144, 97, 249,1)",
                    }}
                  >
                    Start with <b>free 15 days</b> trial. No credit card
                    required.
                  </p>
                </div>
                <div
                  className="mt-5"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    gap: "1.5rem",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <a
                      target="_blank"
                      href="https://appupgrade.dev/signup"
                      className="btn btn-cta btn-full-width outline-text glowing outline-shadow"
                      rel="noreferrer"
                    >
                      Get started →
                    </a>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <a
                      target="_blank"
                      href="mailto:support@appupgrade.dev"
                      className="btn btn-cta btn-full-width outline-text glowing outline-shadow"
                      rel="noreferrer"
                      style={{ padding: ".375rem .75rem" }}
                    >
                      Contact us →
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </section>
  );
};

export default Base64Decoder;
